import React from 'react'
import { useParams } from 'react-router-dom'
import { useRedirectTo } from '@@partner:helpers/hooks/location'

import { Panel } from 'rsuite'
import StoriesForm from '@components/marketing/stories/StoriesForm'

import { ROUTE_MARKETING_STORIES } from '@@partner:config/routes'

export default function StoryFormPage () {
  const { storyId, brandSlug } = useParams<any>()
  const redirectToCatalog = useRedirectTo(ROUTE_MARKETING_STORIES, {
    brandSlug
  })

  return (
    <div className="StoryFormPage">
      <h1 className="u-heading">{storyId ? 'Редактирование' : 'Добавление'}</h1>
      <Panel shaded>
        <StoriesForm storyId={storyId} onSaved={redirectToCatalog} />
      </Panel>
    </div>
  )
}
